<style lang="scss" scoped>
@import "core";

.my-subjects-table {

  &__heading {

    & > th {
      border: 0;
      padding: 0;
      padding-top: 20px;
      background: transparent;
    }

    &:first-child > th {
      padding-top: 0;

      @include mq(pc) {
        padding-top: 10px;
      }
    }
  }

  &__notice {
    font-size: 90%;
    margin-bottom: 5px;
    text-align: left;
  }

  &__category-name {
    display: block;
    border-left: solid 8px $color-primary;
    font-size: 20px;
    font-weight: normal;
    color: #000;
    padding-left: 10px;
    margin-bottom: 10px;
    line-height: 1.4;
    text-align: left;

    &:before {
      content: "";
      display: block;
    }

    @include mq(sp) {
      font-size: 1.7rem;
    }
  }

  &__row {

    & > th {
      text-align: left;
      white-space: nowrap;
    }

    & > td {
      width: 100%;
      padding-top: 5px;

      @include mq(pc) {
        padding-right: 8px;
      }
    }

    &--empty {
      .my-inputed-score {
        &__value {
          font-weight: inherit;
          color: inherit;
          font-size: inherit;
        }
      }
    }
  }
}

.my-subject-body {
  @include clearfix;

  &__row {
    &:first-child {
      float: left;
      margin-right: .1em;
    }

    &:last-child {
      margin-top: .8em;
      float: right;
    }
  }
}

.my-label-subject-score {
  display: inline-block;
  margin-top: 5px;
  margin-right: 5px;
  vertical-align: middle;
}

.my-input-subject-score {
  width: 3.5em;
  text-align: center;
}

.my-btns {
  margin-top: 5px;
  display: inline-block;
  vertical-align: middle;
}

.my-btn-regist-subject-score {
  min-width: 0;

  @include mq(pc) {
    padding-left: 7px;
    padding-right: 7px;
  }
}

.my-btn-clear-subject-score {
  min-width: 0;
  margin-left: 5px;
  margin-right: 5px;

  @include mq(pc) {
    padding-left: 7px;
    padding-right: 7px;
  }
}

.my-inputed-score {
  display: inline-block;
  vertical-align: middle;

  @include mq(pc) {
    margin-right: .25em;
  }

  @include mq(sp) {
    margin-right: 1em;
  }

  &__value {
    font-weight: bold;
    color: $color-primary;
    font-size: 114%;
  }
}

.my-computed-deviation {
  display: inline-block;
  vertical-align: middle;
}

.my-total-score {
  margin-top: 30px;
  text-align: center;
  font-weight: bold;
  border: solid 1px $color-divider;
  background: $color-bg-base;

  padding: 25px 20px;
  font-size: 16px;

  @include mq(sp) {
    padding: 10px 10px;
  }

  &__prefix {
    @include mq(sp) {
      display: block;
    }
  }
  &__detail {
    @include mq(sp) {
      display: block;
    }
  }

  &__value:not(&__value--empty) {
    font-size: 175%;
    color: $color-primary;
  }
}

.my-commit-all {
  margin-top: 20px;
  text-align: center;

  &__notice {
    text-align: left;
    margin-bottom: 20px;
  }

  &__btn {
    @include mq(pc) {
      min-width: 300px;
    }

    @include mq(sp) {
      width: 100%;
    }

    .dn-icon {
      margin-top: -.15em;
    }
  }
}

.my-to-checker,
.my-to-search {
  margin-top: 20px;
  text-align: center;

  &__guide {
    margin: 20px 0;
  }

  &__btn {
    @include mq(pc) {
      min-width: 300px;
    }

    @include mq(sp) {
      width: 100%;
    }

    @media all and (max-width: 400px) {
      font-size: 11px;
      padding-left: 0;
      padding-right: 0;
    }
  }
}

.my-commit-category__btn {
  margin-left: 1.5em;
  min-width: 100px;
}

.my-section__head-group {
  @include mq(pc) {
    margin-left: 186px;
  }
  .dn-heading-2 {
    text-align: left;
  }
}
.dn-tabs-top {
  margin-bottom: 25px;
  border-top: solid 1px $color-divider;
  a {
    @include mq(sp) {
      width: 100%;
    }
    margin-bottom: 25px;
  }
}
.dn-tabs {
  &__next {
    border-top: solid 1px $color-divider;
  }
}
.tar {
  .dn-btn {
    @include mq(sp) {
      width: 100%;
    }
  }
}
.my-btn-under  {
  @include mq(sp) {
    width: 100%;
  }

  @include mq(pc) {
    min-width: 360px;
  }

  @media all and (max-width: 400px) {
    font-size: 11px;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>



<template>
  <div id="pg-app">
    <template v-if="$store.getters['config/isManabi']">
    <div class="dn-tabs__items">
      <div class="dn-tabs__content dn-tabs__content--active dn-tabs-top">
        <p class="mb20">「模試結果の取得」を押して、進研模試 3年10月の受験結果を登録しましょう。</p>
        <div class="tar">
          <dn-btn
            primary
            v-if="$store.getters['config/isManabi']"
            @click="getOctoberScoreInit()">
            模試結果の取得
          </dn-btn>
        </div>
        <p>登録した内容で志望校の合格可能性判定を入力できます。<br>成績が取得できない場合は、手動で受験結果を入力し、登録してください。</p>
      </div>
    </div>
    
    <div class="dn-tabs__bar">
      <div class="dn-tabs__container">
        <a href="./index.html" class="dn-tabs__item dn-tabs__item--active">
          進研模試 3年10月
        </a>
        <a href="../../jikosaiten/index.html" class="dn-tabs__item">
          自己採点
        </a>
      </div>
    </div>
    <div class="dn-tabs__items">
      <div class="dn-tabs__content dn-tabs__content--active">
        <div class="my-subject-categories" v-if="isReady">
          <table class="my-subjects-table dn-table">
            <template
              class="my-subject-category"
              v-for="(category, categoryIndex) in SUBJECT_CATGORYIES"
            >
              <tr
                class="my-subjects-table__heading"
                :key="categoryIndex"
              >
                <th colspan="2">
                  <span class="my-subjects-table__category-name">
                    {{category.name}}
                    <dn-btn
                      class="my-commit-category__btn"
                      accent
                      sm
                      :disabled="!hasUnCommit"
                      @click="commitScore()"
                    >得点登録</dn-btn>
                  </span>

                  <template v-if="category.id === '1'">
                    <p class="my-subjects-table__notice">国・現古漢／現古を受験した人は、現代文、現古にも得点を入力してください。</p>
                    <p class="my-subjects-table__notice">国・現のみを受験した人は、現代文にも得点を入力してください。</p>
                  </template>
                </th>
              </tr>
              <tr
                class="my-subjects-table__row"
                :class="{
                  'my-subjects-table__row--empty': isEmptyScore(subjectsInput[subject.id]),
                }"
                v-for="(subject, subjectIndex) in category.subjects"
                :key="`${subject.id}_${subjectIndex}`"
              >
                <th>
                  {{subject.name}}
                </th>
                <td>
                  <div class="my-subject-body">
                    <div class="my-subject-body__row">
                      <label class="my-label-subject-score">
                        <dn-ls-text-field
                          class="my-input-subject-score"
                          :name="`bible-mock-input-${subject.id}`"
                          type="tel"
                          number
                          min="0"
                          :max="subjects[subject.id].max"
                          manual
                          :disabled="subjectsDisabled[subject.id]"
                          :ref="`subjectScoreFields-${subject.id}`"
                          @change-has-un-commit="onChangeSubjectUnCommit(subject, $event)"
                          @commit="subjectsInput[subject.id] = $event"
                          @ready="subjectsInput[subject.id] = $event"
                          @input="onInputSubject(subject, $event)"
                          @enter.prevent.stop
                        />
                        <span class="vam">点</span>
                      </label>
                      <div class="my-btns">

                        <!--
                        <dn-btn
                          class="my-btn-regist-subject-score"
                          accent
                          sm
                          :disabled="!subjectsUnCommit[subject.id]"
                          @click="commitScore(subject)"
                        >登録</dn-btn>
                        -->

                        <dn-btn
                          class="my-btn-clear-subject-score"
                          sm
                          :disabled="!subjectsHasScore[subject.id]"
                          @click="clearScore(subject,false)"
                        >削除</dn-btn>
                      </div>
                    </div>
                    <div class="my-subject-body__row">
                      <div class="my-inputed-score">
                        <span class="my-inputed-score__value">{{displayScore(subjectsInput[subject.id], '---')}}</span>/<span class="my-inputed-score__max">{{subjects[subject.id].max}}</span>点
                      </div>
                      <div class="my-computed-deviation" v-if="showDeviation">
                        <span>偏差値：</span><span class="my-computed-deviation__value">{{displayDeviation(subject.id, '--')}}</span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </table>

          <div class="my-commit-all">
            <p class="my-commit-all__notice">入力した得点は正しいですか？<br>入力に間違いがあると正しい合格可能性判定ができません。</p>

            <dn-btn
              class="my-commit-all__btn"
              accent
              :disabled="!hasUnCommit"
              @click="commitScore()"
            >
              <dn-icon
                icon="arrow-right"
                :class="{
                  'is-white': hasUnCommit,
                  'is-disabled': !hasUnCommit,
                }"
              />
              すべて登録する
            </dn-btn>
          </div>
        </div>
        <div v-else-if="isError" class="dn-text--danger">ファイルの読み込みに失敗しました。ブラウザをリロードしてもう一度お試しください。</div>
        <dn-loading-spinner v-else />
        <dn-dialog ref="dialog-alert_success">
          <div slot="header"></div>
          <div class="my-body">取得に成功しました。</div>
          <div slot="footer">
            <dn-btn block-sp @click.native.stop="$refs['dialog-alert_success'].hide">OK</dn-btn>
          </div>
        </dn-dialog>
        <dn-dialog ref="dialog-alert_noscore">
          <div slot="header"></div>
          <div class="my-body">成績がありませんでした。</div>
          <div slot="footer">
            <dn-btn block-sp @click.native.stop="$refs['dialog-alert_noscore'].hide">OK</dn-btn>
          </div>
        </dn-dialog>
        <dn-dialog ref="dialog-alert_scoreerr">
          <div slot="header"></div>
          <div class="my-body">通信に失敗しました。</div>
          <div slot="footer">
            <dn-btn block-sp @click.native.stop="$refs['dialog-alert_scoreerr'].hide">OK</dn-btn>
          </div>
        </dn-dialog>
      </div>
    </div>
    <div class="dn-tabs__items" style="text-align:center;">
      <dn-icon icon="tri-down--lg" />
      <div class="dn-tabs__content dn-tabs__content--active dn-tabs__next">
        <p class="mb10" style="font-size:16px;">次に、志望校を登録しましょう</p>
        <dn-btn accent class="my-btn-under my-btn-to-checker" href="../search/index.html" v-linkset="'C36'" style="font-size:14px;">STEP2 志望校の登録へ　＞＞</dn-btn>
      </div>
    </div>
    </template>
    <template v-else>
    <div class="tar">
      <dn-btn
        primary
        v-if="$store.getters['config/isManabi']"
        @click="getOctoberScore()">
        成績の取得
      </dn-btn>
    </div>
    <div class="my-subject-categories" v-if="isReady">
      <table class="my-subjects-table dn-table">
        <template
          class="my-subject-category"
          v-for="(category, categoryIndex) in SUBJECT_CATGORYIES"
        >
          <tr
            class="my-subjects-table__heading"
            :key="categoryIndex"
          >
            <th colspan="2">
              <span class="my-subjects-table__category-name">
                {{category.name}}
                <dn-btn
                  class="my-commit-category__btn"
                  accent
                  sm
                  :disabled="!hasUnCommit"
                  @click="commitScore()"
                >得点登録</dn-btn>
              </span>

              <template v-if="category.id === '1'">
                <p class="my-subjects-table__notice">国・現古漢／現古を受験した人は、現代文、現古にも得点を入力してください。</p>
                <p class="my-subjects-table__notice">国・現のみを受験した人は、現代文にも得点を入力してください。</p>
              </template>
            </th>
          </tr>
          <tr
            class="my-subjects-table__row"
            :class="{
              'my-subjects-table__row--empty': isEmptyScore(subjectsInput[subject.id]),
            }"
            v-for="(subject, subjectIndex) in category.subjects"
            :key="`${subject.id}_${subjectIndex}`"
          >
            <th>
              {{subject.name}}
            </th>
            <td>
              <div class="my-subject-body">
                <div class="my-subject-body__row">
                  <label class="my-label-subject-score">
                    <dn-ls-text-field
                      class="my-input-subject-score"
                      :name="`bible-mock-input-${subject.id}`"
                      type="tel"
                      number
                      min="0"
                      :max="subjects[subject.id].max"
                      manual
                      :disabled="subjectsDisabled[subject.id]"
                      :ref="`subjectScoreFields-${subject.id}`"
                      @change-has-un-commit="onChangeSubjectUnCommit(subject, $event)"
                      @commit="subjectsInput[subject.id] = $event"
                      @ready="subjectsInput[subject.id] = $event"
                      @input="onInputSubject(subject, $event)"
                      @enter.prevent.stop
                    />

                    <!--
                      @enter="commitScore(subject, $event)"
                    -->

                    <span class="vam">点</span>
                  </label>
                  <div class="my-btns">

                    <!--
                    <dn-btn
                      class="my-btn-regist-subject-score"
                      accent
                      sm
                      :disabled="!subjectsUnCommit[subject.id]"
                      @click="commitScore(subject)"
                    >登録</dn-btn>
                    -->

                    <dn-btn
                      class="my-btn-clear-subject-score"
                      sm
                      :disabled="!subjectsHasScore[subject.id]"
                      @click="clearScore(subject,false)"
                    >削除</dn-btn>
                  </div>
                </div>
                <div class="my-subject-body__row">
                  <div class="my-inputed-score">
                    <span class="my-inputed-score__value">{{displayScore(subjectsInput[subject.id], '---')}}</span>/<span class="my-inputed-score__max">{{subjects[subject.id].max}}</span>点
                  </div>
                  <div class="my-computed-deviation" v-if="showDeviation">
                    <span>偏差値：</span><span class="my-computed-deviation__value">{{displayDeviation(subject.id, '--')}}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </table>

      <div class="my-commit-all">
        <p class="my-commit-all__notice">入力した得点は正しいですか？<br>入力に間違いがあると正しい合格可能性判定ができません。</p>

        <dn-btn
          class="my-commit-all__btn"
          accent
          :disabled="!hasUnCommit"
          @click="commitScore()"
        >
          <dn-icon
            icon="arrow-right"
            :class="{
              'is-white': hasUnCommit,
              'is-disabled': !hasUnCommit,
            }"
          />
          すべて登録する
        </dn-btn>
      </div>

      <!--
      <div class="my-total-score">
        <span class="my-total-score__prefix">あなたの総合得点は</span>
        <span class="my-total-score__detail">
          <span><span class="my-total-score__value" :class="{'my-total-score__value--empty': total.score === null}">{{total.score === null ? '---' : total.score}}</span>点</span>
          <span>/</span>
          <span>{{total.max === null ? '---' : total.max}}点です</span>
        </span>
      </div>
      -->

<!--
      <div class="my-to-checker">
        <dn-btn
          class="my-to-checker__btn"
          accent
          href="../../jikosaiten/hantei/index.html"
          linkset="C36"
        >
          合格可能性判定{{$store.getters['config/isManabi'] ? '' : '　判定チェッカー'}}
        </dn-btn>
      </div>
-->
      <div class="my-to-search">
        <p class="my-to-search__guide">志望大学の登録はお済みですか？まだの方は今すぐ登録しましょう！</p>
        <dn-btn
          class="my-to-search__btn"
          accent
          href="../search/index.html"
          linkset="B6"
        >
          志望大学検索・登録
        </dn-btn>
      </div>
    </div>
    <div v-else-if="isError" class="dn-text--danger">ファイルの読み込みに失敗しました。ブラウザをリロードしてもう一度お試しください。</div>
    <dn-loading-spinner v-else />
    <dn-dialog ref="dialog-alert_noscore">
      <div slot="header"></div>
      <div class="my-body">成績がありませんでした。</div>
      <div slot="footer">
        <dn-btn block-sp @click.native.stop="$refs['dialog-alert_noscore'].hide" style="margin-left:7em">OK</dn-btn>
      </div>
    </dn-dialog>
    <dn-dialog ref="dialog-alert_scoreerr">
      <div slot="header"></div>
      <div class="my-body">通信に失敗しました。</div>
      <div slot="footer">
        <dn-btn block-sp @click.native.stop="$refs['dialog-alert_scoreerr'].hide" style="margin-left:7em">OK</dn-btn>
      </div>
    </dn-dialog>
    </template>
  </div>
</template>



<script>
import MockSubject from 'models/MockSubject';
import 'whatwg-fetch';



const SUBJECT_CATGORYIES = MockSubject.findCategories(null, true);
const MOCK_CATEGORIES    = MockSubject.CATEGORIES;
const MOCK_SUBJECTS      = MockSubject.SUBJECTS;
const MOCK_JAP_PARENT_SUBJECTS = MOCK_SUBJECTS.filter(subject => subject.categoryId === '1' && !!subject.children);
const MOCK_JAP_CHILD_SUBJECTS = MOCK_SUBJECTS.filter(subject => subject.categoryId === '1' && !subject.children);
const MOCK_MATH_SUBJECTS = MOCK_SUBJECTS.filter(subject => subject.categoryId === '2');
const MOCK_SOCI_SUBJECTS = MOCK_SUBJECTS.filter(subject => subject.categoryId === '4');
const MOCK_SCIE_SUBJECTS = MOCK_SUBJECTS.filter(subject => subject.categoryId === '5');



const subjectsInput = {};
const subjectsUnCommit = {};
const subjectsHasScore = {};
const subjectsDisabled = {};


MockSubject.SUBJECTS.forEach(subject => {
  subjectsInput[subject.id] = null;
  subjectsUnCommit[subject.id] = false;
  subjectsHasScore[subject.id] = false;
  subjectsDisabled[subject.id] = false;
});



export default {
  data() {
    return {
      state: 'pending',
      subjectsInput: subjectsInput,
      subjectsUnCommit: subjectsUnCommit,
      subjectsHasScore: subjectsHasScore,
      subjectsDisabled: subjectsDisabled,
      subjects: null,
    }
  },



  computed: {
    showDeviation() { return this.$store.getters['config/envIs']('test') },
    seisekiApiConfig() { return this.$store.getters['config/seisekiApi'] },
    isReady() { return this.state === 'ready' },
    isError() { return this.state === 'error' },
    SUBJECT_CATGORYIES() { return SUBJECT_CATGORYIES },
    allSubjects() {
      let subjects = [];
      this.SUBJECT_CATGORYIES.forEach(category => {
        subjects = subjects.concat(category.subjects);
      });
      return subjects;
    },
    unCommitSubjects() {
      return this.allSubjects.filter(subject => this.subjectsUnCommit[subject.id]);
    },
    total() {
      let score = null;
      let max   = null;

      const inputedMap = this.subjectsInput;

      for (let id in inputedMap) {
        const subjectScore = parseInt(this.subjectsInput[id], 10);
        if (isNaN(subjectScore)) continue;
        if (score === null) score = 0;
        score += subjectScore;
        if (max === null) max = 0;
        max += this.subjects[id].max;
      }
      return {score: score, max: max};
    },
    hasUnCommit() {
      let hasUnCommit = false;
      for (let id in this.subjectsUnCommit) {
        if (this.subjectsUnCommit[id]) {
          hasUnCommit = true;
          break;
        }
      }
      return hasUnCommit;
    },
  },



  methods: {
    isEmptyScore(score) {
      return (score === '' || score === null || score === undefined);
    },
    displayScore(score, defaultScore) {
      return this.isEmptyScore(score) ? defaultScore : score;
    },
    displayDeviation(subjectId, defaultDeviation) {
      const input = this.subjectsInput[subjectId];
      if (this.isEmptyScore(input)) return defaultDeviation;
      return this.subjectModel.getDeviationByScoreAndSubjectId(parseInt(input, 10), subjectId);
    },
    getInputById(id) {
      const $ref = this.$refs[`subjectScoreFields-${id}`];
      return $ref ? $ref[0] : null;
    },
    getInputValueById(id) {
      const input = this.getInputById(id);
      return input ? input.internalInputValue : null;
    },

    /**
     * コミットしようとしている状態のバリデーションを行う
     * コミット要求の科目は入力フィールドの値
     * それ以外はコミット済みの値でバリデーションする
     */
    validateInputs(subjects) {
      const errors = [];
      const needs  = [];
      const uses   = {};
      const mergedInput = Object.assign({}, this.subjectsInput);

      subjects.forEach(subject => {
        uses[subject.id] = true;
        mergedInput[subject.id] = this.getInputValueById(subject.id);
      });

      // 国語の親科目は1科目までしか選べない
      if (MOCK_JAP_PARENT_SUBJECTS.find(subject => uses[subject.id])) {
        const japCount = MOCK_JAP_PARENT_SUBJECTS.filter(subject => mergedInput[subject.id] !== null).length;
        if (japCount > 1) {
          errors.push('「国・現古漢」、「国・現古」、「国・現のみ」はいずれか1科目しか登録できません。');
        }

        // 国語の親科目の点数が全てnullになる場合は子科目の点数を消す
        if (!MOCK_JAP_PARENT_SUBJECTS.find(subject => mergedInput[subject.id] !== null)) {
          MOCK_JAP_CHILD_SUBJECTS.forEach(subject => {
            needs.push({id: subject.id, value: null});
          });
        }
      }

      // 国語の小科目はいずれかの親科目が点数入力されていて、その親科目の子科目として設定されていない場合は登録できない
      if (MOCK_JAP_CHILD_SUBJECTS.find(subject => uses[subject.id])) {
        const childSubjects = MOCK_JAP_CHILD_SUBJECTS.filter(subject => mergedInput[subject.id] !== null);

        childSubjects.forEach(child => {
          const parentSubjects = MOCK_JAP_PARENT_SUBJECTS.filter(subject => subject.children.includes(child.id));
          if (!parentSubjects.find(subject => mergedInput[subject.id] !== null)) {
            const parentNames = parentSubjects.map(subject => `「${subject.name}」`).join('、');
            errors.push(`「${child.name}」を登録するためには${parentNames}のいずれかの登録が必要です。`);
          }
        });
      }

      // 国語の親科目と子科目（現代文:110）の点数の整合性チェック
      // ※NGパターン
      //   a.【選択している親科目】 < 現代文
      //   b.【選択している親科目】 - 現代文 > 100
      //     ①国・現古漢　＜　現代文
      //     ②国・現古　　＜　現代文
      //     ③国・現のみ　＜　現代文
      //     ④国・現古漢　-　現代文　>　100
      //     ⑤国・現古　　-　現代文　>　100
      //     ⑥国・現のみ　-　現代文　>　100
      if (uses['110'] || MOCK_JAP_PARENT_SUBJECTS.find(subject => uses[subject.id])) {
        const childId = '110';

        let parentSubject, parentScore, childScore = mergedInput[childId];

        // 現代文の得点は削除されている可能性もあるので両方から探す
        const needChild = needs.find(need => need.id === childId);
        if (needChild) childScore = needChild.value;

        childScore = childScore || 0;

        for (let subject of MOCK_JAP_PARENT_SUBJECTS) {
          if (mergedInput[subject.id] !== null) {
            parentSubject = subject;
            parentScore = mergedInput[subject.id];
          }
        }

        const isFailed = (parentScore < childScore) // a
                || ((parentScore - childScore) > 100) // b
                || false;

        if (isFailed) {
          errors.push(`${parentSubject.name}と内訳（現代文の得点）に不整合があります。入力内容を確認してください。`);
        }
      }



      // 数学は1科目までしか選べない
      if (MOCK_MATH_SUBJECTS.find(subject => uses[subject.id])) {
        const mathCount = MOCK_MATH_SUBJECTS.filter(subject => mergedInput[subject.id] !== null).length;
        if (mathCount > 1) {
          errors.push('数学は1科目までしか登録できません。');
        }
      }

      // 地歴公民は3科目までしか選べない
      if (MOCK_SOCI_SUBJECTS.find(subject => uses[subject.id])) {
        const sociCount = MOCK_SOCI_SUBJECTS.filter(subject => mergedInput[subject.id] !== null).length;
        if (sociCount > 3) {
          errors.push('地歴公民は3科目までしか登録できません。');
        }
      }

      // 理科は3科目までしか選べない
      if (MOCK_SCIE_SUBJECTS.find(subject => uses[subject.id])) {
        const scieCount = MOCK_SCIE_SUBJECTS.filter(subject => mergedInput[subject.id] !== null).length;
        if (scieCount > 3) {
          errors.push('理科は3科目までしか登録できません。');
        }
      }

      return {errors, needs};
    },

    commitScore(subjects = this.unCommitSubjects) {
      subjects = Array.isArray(subjects) ? subjects : [subjects];
      const validateResult = this.validateInputs(subjects);

      if (validateResult.errors.length) {
        dn.$alert(validateResult.errors.join('\n'));
        return validateResult.errors;
      }
      validateResult.needs.forEach(need => {
        this.getInputById(need.id).inputValue = need.value;
        if (!subjects.find(subject => subject.id === need.id)) {
          subjects.push(this.allSubjects.find(subject => subject.id === need.id));
        }
      });
      this.$nextTick(() => {
        subjects.forEach(subject => {
          this.getInputById(subject.id).commit();
        });
      });
    },

    // 成績取得初期設定
    getOctoberScoreInit() {
      // 成績取得前にデータをクリアする
      this.allSubjects.forEach(sub => {
        this.clearScore(sub,true);
      });

      // 通信
      this.getOctoberScore();

    },

    // 記述回の成績を取得
    getOctoberScore(){
              // 10月の成績を取得
              window.fetch(/*"../../data/examRslt.json"*/
                    this.seisekiApiConfig.domain.manabi + "seiseki/services/dnExamRslt",
                    {
                      credentials: "include",
                      headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                      },
                      referrer: this.seisekiApiConfig.domain.dn,
                      referrerPolicy: "no-referrer-when-downgrade",
                      body: "{\"examId\":\"" + this.seisekiApiConfig.examId.moshi.replace("{GAKUNEN}", "K3") + "\"}",
                      method: "POST",
                      mode: "cors"
                    }
                    ).then(exm_response => {
                      return exm_response.json();

                    }).then(octoberScore => {

                      if (!octoberScore.seiseki) {
                        // 通信エラー
                        (this.$refs[`dialog-alert_noscore`]).show();
                        return;
                      } else if (!octoberScore.seiseki.seisekiList) {
                        // 成績が無い場合
                        // (this.$refs[`dialog-alert_noscore`]).show();
                        // 高校3年生で成績が取れない場合、既卒で取りに行く
                        this.getOctoberScoreKisotu();
                        return;
                      } else {
                        // 成績がある場合
                        (this.$refs[`dialog-alert_success`]).show();
                      }

                      let subjectScore = $.grep(octoberScore.seiseki.seisekiList,
                        function(score) {
                          return score.kmkType === 2;
                        });

                      if (subjectScore.length < 1) {
                        (this.$refs[`dialog-alert_noscore`]).show();
                        return;
                      }

                      subjectScore.forEach(score => {
                        let id = score.kmkCrsCd.slice(-3);
                        let input = this.getInputById(id);

                        if (input) {
                          // input.inputValue = this.subjectModel.getScoreByDeviationAndSubjectId(score.zenSs, id);
                          input.inputValue = score.keiten;
                          input.commit();
                        }
                      });

                    }).catch(exm_err => {
                      (this.$refs[`dialog-alert_scoreerr`]).show();
                    });
    },

    // 記述回の成績を取得（既卒用）
    getOctoberScoreKisotu(){
              // 10月の成績を取得
              window.fetch(/*"../../data/examRslt.json"*/
                    this.seisekiApiConfig.domain.manabi + "seiseki/services/dnExamRslt",
                    {
                      credentials: "include",
                      headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json"
                      },
                      referrer: this.seisekiApiConfig.domain.dn,
                      referrerPolicy: "no-referrer-when-downgrade",
                      body: "{\"examId\":\"" + this.seisekiApiConfig.examId.moshi.replace("{GAKUNEN}", "S4") + "\"}",
                      method: "POST",
                      mode: "cors"
                    }
                    ).then(exm_response => {
                      return exm_response.json();

                    }).then(octoberScore => {

                      if (!octoberScore.seiseki) {
                        // 通信エラー
                        (this.$refs[`dialog-alert_noscore`]).show();
                        return;
                      } else if (!octoberScore.seiseki.seisekiList) {
                        // 成績が無い場合
                        (this.$refs[`dialog-alert_noscore`]).show();
                        return;
                      } else {
                        // 成績がある場合
                        (this.$refs[`dialog-alert_success`]).show();
                      }

                      let subjectScore = $.grep(octoberScore.seiseki.seisekiList,
                        function(score) {
                          return score.kmkType === 2;
                        });

                      if (subjectScore.length < 1) {
                        (this.$refs[`dialog-alert_noscore`]).show();
                        return;
                      }

                      subjectScore.forEach(score => {
                        let id = score.kmkCrsCd.slice(-3);
                        let input = this.getInputById(id);

                        if (input) {
                          // input.inputValue = this.subjectModel.getScoreByDeviationAndSubjectId(score.zenSs, id);
                          input.inputValue = score.keiten;
                          input.commit();
                        }
                      });

                    }).catch(exm_err => {
                      (this.$refs[`dialog-alert_scoreerr`]).show();
                    });
    },

    async clearScore(subject,allClear) {

      const myDefine   = MOCK_SUBJECTS.find(define => define.id === subject.id);
      const myChildIds = myDefine.children || [];

      // 国語現代文と親科目のバリデーションをここでも
      if (myDefine.id === '110') {

        // 現代文が削除されるので親科目に入力がないか調べる
        let parentSubject, parentScore;
        for (let subject of MOCK_JAP_PARENT_SUBJECTS) {
          parentScore = this.subjectsInput[subject.id];
          if (parentScore !== null) {
            parentSubject = subject;
            break;
          }
        }

        if (parentSubject) {
          if (parentScore > 100) {
            dn.$alert(`${parentSubject.name}と内訳（現代文の得点）に不整合があります。入力内容を確認してください。`);
            return false;
          }
        }
      }

      // 国語の小科目はいずれか親科目が点数入力されていないと登録できないため、関連子科目も削除する
      const children = myChildIds.map(id => MOCK_SUBJECTS.find(define => define.id === id));
      const childrenInputs = [];
      children && children.forEach(child => {
        const childInput = this.getInputById(child.id);
        if (childInput.inputValue !== null && childInput.inputValue !== '') {
          childrenInputs.push({$el: childInput, name: child.name});
        }
      });

      const targets = [{$el: this.getInputById(subject.id), name: myDefine.name}, ...childrenInputs];

      // 単一項目クリア時のみアラートを表示する
      if (!allClear){
        if (!await dn.$confirm(`${subject.name}の得点をクリアしてもよろしいですか？`)) return;
      }

      targets.forEach(target => {
        target.$el.inputValue = null;
        target.$el.commit();
      });
    },

    onChangeSubjectUnCommit(subject, hasUnCommit) {
      this.subjectsUnCommit[subject.id] = hasUnCommit;
    },

    onInputSubject(subject, value) {
      const hasScore = value !== null && value !== '';
      this.subjectsHasScore[subject.id] = hasScore;
      this.updateSubjectsDisabled();
    },

    updateSubjectsDisabled() {
      const subjectsHasScore = this.subjectsHasScore;
      const subjectsDisabled = {};

      const maxCheck = (ids, max) => {
        const hasScores = [];
        const noScores = [];
        for (let id of ids) {
          if (subjectsHasScore[id]) {
            hasScores.push(id);
          } else {
            noScores.push(id);
          }
        }
        if (hasScores.length >= max) {
          for (let id of noScores) {
            subjectsDisabled[id] = true;
          }
        }
      }

      // 国語の親科目はいずれか1科目のみ入力可能
      maxCheck(MOCK_JAP_PARENT_SUBJECTS.map(s => s.id), 1);

      // 現代文(110)、現古(130)は
      // 国・現古漢(101)、国・現古(102)、国・現のみ(103)いずれかの入力が必要
      if (
        !subjectsHasScore['101']
        && !subjectsHasScore['102']
        && !subjectsHasScore['103']
      ) {
        subjectsDisabled['110'] = true;
        subjectsDisabled['130'] = true;
      }

      // 現古(130)は国・現のみ(103)を選択した時は無効
      if (subjectsHasScore['103']) {
        subjectsDisabled['130'] = true;
      }

      // 数学はいずれか1科目のみ入力可能
      maxCheck(MOCK_MATH_SUBJECTS.map(s => s.id), 1);

      // 地歴公民はいずれか3科目のみ入力可能
      maxCheck(MOCK_SOCI_SUBJECTS.map(s => s.id), 3);

      // 理科はいずれか3科目のみ入力可能
      maxCheck(MOCK_SCIE_SUBJECTS.map(s => s.id), 3);

      // 無効になった科目は全て得点を削除する
      for (let id in subjectsDisabled) {
        const el = this.getInputById(id);
        el.inputValue = null;
        el.commit();
      }

      this.subjectsDisabled = subjectsDisabled;
    },

    async loadSubjects() {
      const _subjects = await this.subjectModel.load();
      const subjects  = {};

      _subjects.forEach(subject => {
        subjects[subject.id] = {
          avg: subject.avg,
          sd : subject.sd,
          max: subject.max,
        };
      });
      this.subjects = subjects;
    },
    async init() {
      this.state = 'initing';

      try {
        await this.loadSubjects();
        this.state = 'ready';
      } catch(e) {
        this.state = 'error';
      }
    },
  },

  created() {
    this.subjectModel = new MockSubject();
    wait(1000, () => {
      console.log("wait");
      this.init();
    });
  },
}
const wait = (ms, callback) => {
  setTimeout(() => {
    callback(); // 指定`ms`後にコールバックを実行する
  }, ms);
}
</script>



// WEBPACK FOOTER //
// App.vue?6db8b5df